import { render, staticRenderFns } from "./UserMana.vue?vue&type=template&id=298ab8d2&"
import script from "./UserMana.vue?vue&type=script&lang=js&"
export * from "./UserMana.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports